import { Injectable } from '@angular/core';
import type { PlanFactSettingsInterface } from '@zaoblako/shared/modules/saas/dtos/plan-fact-settings/plan-fact-settings.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlanFactSettingsService extends BaseService {
  protected baseUrl = '/finance/plan-fact/settings';

  public getSettings(): Observable<PlanFactSettingsInterface> {
    return this.http.get<PlanFactSettingsInterface>(this.baseUrl);
  }

  public setSettings(params: PlanFactSettingsInterface): Observable<PlanFactSettingsInterface> {
    return this.http.put<PlanFactSettingsInterface>(this.baseUrl, params);
  }
}
